module.exports = __webpack_public_path__ + "img/equity_icon20.bf15b480.png";